import { DemoData } from '../types';
import { IFormsLicense, IFormsLicenseRequest } from '../types/IFormsLicense';
import { Fetch } from './Fetch';

export const FormsLicense = {
	post: (body: IFormsLicenseRequest): Promise<IFormsLicense> =>
		Fetch.post('/management/forms-license', body),

	getList: (organizationId: string): Promise<IFormsLicense[]> =>
		DemoData.enabled ?
			new Promise<IFormsLicense[]>(resolve => resolve([])) :
			Fetch.get(`/management/organization/${organizationId}/forms-licenses`),
};
